import { controls, grouped } from "../controls";
const update_cf_batch_numbers = {
  label: "Update Cf Batch Numbers",
  pageLabel: "Update Cf Batch Numbers", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  formTabs:
  {
    allTabs: [
      { label: "General", uid: "general" },
      { label: "Update Cf Batch Number Footers", uid: "update_cf_batch_number_footers", fastpath: "update_cf_batch_number_footers" }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", label: "Taluka" }),
    ...controls.oc({ tab: "filter", c: "Taluka", placeHolder: "Taluka Code", name: "UpdateCFBatchNumber-taluka-taluka_code", fastpath: "talukas" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "UpdateCFBatchNumber-taluka-taluka_display" }),
    ...controls.displayText({ tab: "filter", label: "User" }),
    ...controls.oc({ tab: "filter", c: "User", placeHolder: "User Code", name: "UpdateCFBatchNumber-talathi-user_code", fastpath: "users" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "UpdateCFBatchNumber-talathi-user_display" }),
    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Updated Count" }),
    ...controls.numberOnly({ tab: "filter", placeHolder: "", name: "updated_count", maxlength: 200 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Updated Amount" }),
    ...controls.numberOnly({ tab: "filter", placeHolder: "", name: "updated_amount", maxlength: 200 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Taluka", star: false }),
    ...controls.oc({ tab: "general", c: "Taluka", placeHolder: "Taluka Code", name: "taluka_code", fastpath: "talukas", isReadOnly: "edit", hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display" }),
    ...controls.displayText({ tab: "general", label: "Talathi Mobile", star: false }),
    ...controls.oc({ tab: "general", c: "User", placeHolder: "Talathi Mobile", name: "talathi_code", fastpath: "users", isReadOnly: "edit", displayData: { user_display: "talathi_display", user_uid: "talathi_uid" }, hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "talathi_display" }),
    ...controls.magicDateLabel({ tab: "general", label: "As On Date", target: "as_on_date", star: true }),
    ...controls.magicDate({ tab: "general", name: "as_on_date", dateType: "ontype", isRequired: true, isReadOnly: "edit", default: "n" }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Updated Count", star: false }),
    ...controls.numberOnly({ tab: "general", placeHolder: "", name: "updated_count", maxlength: 200, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Updated Amount", star: false }),
    ...controls.numberOnly({ tab: "general", placeHolder: "", name: "updated_amount", maxlength: 200, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Transaction Batch Number", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "transaction_batch_number", isRequired: true, maxlength: 50, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "update_cf_batch_number_footers", label: "Particulars", star: false }),
    ...controls.text({ tab: "update_cf_batch_number_footers", placeHolder: "", name: "particulars", width: "col-sm-4", maxlength: 100 }),

    ...controls.displayText({ tab: "update_cf_batch_number_footers", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "update_cf_batch_number_footers", width: "col-sm-2", label: "" }),
    ...controls.button({
      tab: "update_cf_batch_number_footers",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "update_cf_batch_number_footers",
        requiredField: ["particulars",],
        required: [],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "update_cf_batch_number_footers",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "update_cf_batch_number_footers",
        requiredField: ["particulars",]
      }, width: "col-sm-2"
    }),

    ...controls.FileUpload({
      readFile: { targetTable: 'update_cf_batch_number_footers', type: 'csv', columns: ["particulars"] },
      label: "Fileupload",
      name: "bulk_file_upload",
      placeholder: {
        type: "text",
        value: "Upload Bulk files"
      },
      tab: "update_cf_batch_number_footers",
      width: "col-sm-2"
    }),

    {
      tab: "update_cf_batch_number_footers",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Particulars", field: "particulars" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "update_cf_batch_number_footers"
    },
  ]
  , history: {
    perPage: 10,
    reportHeader: "Update Cf Batch Numbers",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "User", accessor: "UpdateCFBatchNumber-talathi-user_display", },
      { Header: "As On Date", accessor: "as_on_date", type: 'date' },
      { Header: "Updated Count", accessor: "updated_count", },
      { Header: "Updated Amount", accessor: "updated_amount", },
    ]
  }
};
export default update_cf_batch_numbers;